export var createTenantApi = function (baseUrl, http) {
    var url = "" + baseUrl;
    var tenantApi = {
        get: function () {
            return http.get("" + url, {});
        },
    };
    return tenantApi;
};
//# sourceMappingURL=index.js.map